module.exports = __webpack_public_path__ + "img/96.d500fec5.jpg";